<template>
  <div class="warpp">
    <el-popover
      placement="bottom-start"
      trigger="hover"
    >
      <div class="feet">
        <!--下载模板-->
        <el-button type="primary" size="small" @click="onDownloadTemplate">{{ $t('basicData.DownloadTheTemplate') }}</el-button>

        <!--批量导入-->
        <upload-excel
          class="feet-btn"
          :on-success="importLogistics"
          :but-name="$t('basicData.BulkImport')"
        />

        <el-button
          class="feet-btn" type="primary" size="small"
          @click="downloadOffer"
        >{{ $t('basicData.DownloadTheQuote') }}</el-button>
      </div>
      <!--导入/下载-->
      <el-button
        slot="reference" size="small" plain
      >{{ $t('basicData.ImportDownload') }}</el-button>
    </el-popover>
  </div>
</template>

<script>
import { downloadTemplate, importTemplate, downloadQuotation } from './utils';

export default {
  components: {
    'upload-excel': () => import('@/components/UploadExcel/index.vue')
  },

  props: {
    // 所有分区
    subregionList: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 下载模板需要的回调函数
    getDataFunc: {
      type: Function,
      required: true
    }
  },

  methods: {
    // 下载模板
    onDownloadTemplate() {
      downloadTemplate(this.subregionList);
    },

    // 批量导入报价
    importLogistics(arr) {
      console.log(arr, '上门揽收导入');
      try {
        const list = importTemplate(arr[0].results, this.subregionList);
        console.log(list, '解析数据');
        this.$emit('importList', list);
      } catch (error) {
        this.$message.warning(this.$t('orderCenterCont.ImportFailed'));
        console.error(error);
      }
    },

    // 下载报价
    downloadOffer() {
      const list = this.getDataFunc();
      downloadQuotation(list, this.subregionList);
    }
  }
};
</script>
